import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
  OnInit,
} from '@angular/core';

export interface IButton {
  title: string;
  value: string;
}

@Component({
  selector: 'mj-radio-button',
  templateUrl: 'radio-button.component.html',
  styleUrls: ['radio-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonComponent implements OnInit {
  @Input() buttons: IButton[];
  @Input() selectedButtonIndex = 0;
  @Output() onRadioButtonValueChange: EventEmitter<string> = new EventEmitter<
    string
  >();

  firstButtonValue: string = '';

  ngOnInit() {
    this.firstButtonValue = this.buttons[this.selectedButtonIndex].value;
    this.onRadioButtonValueChange.emit(this.firstButtonValue);
  }

  public changeButtonValueHandler(value: string) {
    this.onRadioButtonValueChange.emit(value);
  }
}
